module.exports = __webpack_public_path__ + "media/images/hr/logo-hradmin-510000e28ecd6d44c516d52649c17962.svg";